module.exports = __webpack_public_path__ + "static/media/doubleDog3.40a9f3d1.png";